import {bgMarkersFromUrl, markerClassNames} from "./bgMarkers";
import {BLACK_TEXT_SET} from "../data/products/index";

export function workspaceClasses({backgroundUrl, product, channel, backgroundOption, layout}: {
  backgroundUrl: string; product: string; channel: string; backgroundOption: string | number; layout: number;
}) {
  const markers = markerClassNames(bgMarkersFromUrl(backgroundUrl));
  return [markers, BLACK_TEXT_SET.has(product) && !markers.includes("blacktext") ? "blacktext" : "",
    product, channel, backgroundOption === "custom" ? "bg-upload" : `bg-${backgroundOption}`, layout ? `layout-${layout}` : ""].filter(Boolean).join(" ");
}
